const siteConfig = {
  brandName: "arenviko",
  brandTitle: "arenviko",
  companyName: "DAGOTITY INC",
  founderName: "arenviko Studio",
  logo: {
    text: "arenviko",
    initial: "A",
    image: "/img/arenviko-logo.svg",
  },
  tagline: "Modern footwear · Hong Kong",
  description:
    "arenviko creates versatile contemporary footwear with balanced proportions, considered materials and everyday comfort.",
  contact: {
    email: "brand@arenviko.club",
    address: "13918 E Mississippi Ave #60260, Aurora, CO 80012, US",
    openingHours: "Monday – Friday, 10am – 6pm HKT",
  },
  shipping: { flatRate: 9.99 },
  currency: "USD",
  locale: "en-US",
  storageKey: "arenviko-store-v1",
  categories: ["Oxfords", "Derbies", "Boots", "Monk Straps", "Loafers"],
  collections: ["arenviko Core Collection", "arenviko Studio Collection"],
};

export default siteConfig;
